module.exports = __webpack_public_path__ + "static/media/CL 17.08b4ca93.mp3";